import { useRuntime } from '../contexts/RuntimeProvider';
import { webRuntimeApi } from '@/runtime/web';
import type { DefaultView } from '@/runtime/RuntimeStore';

const MODES: { value: DefaultView; label: string }[] = [
  { value: 'graph', label: 'Graph' },
  { value: '2d', label: '2D' },
  { value: '3d', label: '3D' },
];

export const PerformanceModeToggle = () => {
  // Subscribe to runtime state changes so we re-render when defaultView changes
  useRuntime();
  const defaultView = webRuntimeApi.getDefaultView();

  return (
    <div style={{ display: 'inline-flex', borderRadius: 6, overflow: 'hidden' }}>
      {MODES.map(({ value, label }) => (
        <button
          key={value}
          onClick={() => webRuntimeApi.setDefaultView(value)}
          style={{
            padding: '6px 10px',
            background: defaultView === value ? '#3b82f6' : '#374151',
            color: 'white',
            border: 'none',
            borderLeft: value !== 'graph' ? '1px solid rgba(255,255,255,0.1)' : 'none',
            fontSize: 11,
            fontWeight: 500,
            cursor: 'pointer',
            opacity: defaultView === value ? 1 : 0.7,
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
